import { useEffect, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import React from "react";
import { IPlaceWorkFlowModel } from "../modules/services/core/_models";
import { useSearchParams } from "react-router-dom";

const NovoChamadoAtivo: React.FC = () => {
    const [detalhesAlerta, setDetalhesAlerta] = useState<IPlaceWorkFlowModel[]>([]);
    const [searchParams] = useSearchParams();
    const [numeroChamado, setNumeroChamado] = useState<string>("");
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        const obterDetalhesAlerta = async () => {
            const idWorkFlow = searchParams.get("var-IdWorkFlow");
            if (idWorkFlow) {
                try {
                    const response = await fetch(
                        `${backendUrl}/api/PrismWorkFlow/ByWorkFlow/${idWorkFlow}`,
                        {
                            method: "GET",
                        }
                    );
                    const responseJson = await response.json();

                    // Verifique se a resposta é um array ou objeto
                    if (Array.isArray(responseJson)) {
                        setDetalhesAlerta(responseJson); // Caso seja um array
                    } else {
                        // Caso seja um objeto, converta para um array com um único item
                        setDetalhesAlerta([responseJson]);
                    }
                } catch (error) {
                    console.error("Erro ao buscar detalhes do alerta:", error);
                }
            } else {
                console.error("var-IdWorkFlow is null or undefined");
            }
        };

        obterDetalhesAlerta();
    }, [searchParams]);

    const handleSalvarAlteracoes = async () => {
        const idWorkFlow = searchParams.get("var-IdWorkFlow");
        if (idWorkFlow && numeroChamado.trim() !== "") {
            try {
                const response = await fetch(
                    `${backendUrl}/api/PrismWorkFlow`,
                    {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ IdWorkFlow: parseInt(idWorkFlow), Ticket: numeroChamado }),
                    }
                );

                if (response.ok) {
                    alert("Número do chamado atualizado com sucesso");
                } else {
                    console.error("Erro ao atualizar número do chamado:", response.statusText);
                }
            } catch (error) {
                console.error("Erro ao atualizar número do chamado:", error);
            }
        } else {
            alert("Número do chamado não pode estar vazio");
        }
    };

    return (
        <div className="novo-chamado-container d-flex">
            <div style={{ display: "flex", flexDirection: "column", width: "5%", padding: "10px" }}></div>
            <div style={{ width: "90%", padding: "10px" }}>
                <h1 style={{ textAlign: "center", marginBottom: "0px", borderBottom: "0px solid var(--bs-border-color)" }}>
                    Detalhes do Alerta
                </h1>
                <div className="detalhes-alerta">
                    {detalhesAlerta.map((alerta, index) => (
                        <React.Fragment key={index}>
                            <div>Gateway:</div>
                            <div>
                                {(() => {
                                    try {
                                        const data = JSON.parse(alerta.Dados);
                                        return data.Gateway || "N/A";
                                    } catch (error) {
                                        console.error("Erro ao parsear alerta.Data:", error);
                                        return "N/A";
                                    }
                                })()}
                            </div>
                            <div>Nro Chamado:</div>
                            <input
                                type="text"
                                value={numeroChamado}
                                onChange={(e) => setNumeroChamado(e.target.value)}
                            />
                            <div>Assunto:</div>
                            <div>{alerta.Assunto}</div>
                            <div>Requisitante:</div>
                            <div>{alerta.IdUsuarioOwner}</div>
                            <div>Responsável:</div>
                            <div>{alerta.IdUsuarioResponsible}</div>
                            <div>Criação:</div>
                            <div>{alerta.DataCriacao}</div>
                        </React.Fragment>
                    ))}
                </div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <button
                        className="botao-salvar"
                        onClick={handleSalvarAlteracoes}
                    >
                        Salvar Alterações
                    </button>
                </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: "5%", padding: "10px" }}></div>
        </div>
    );
};

export default NovoChamadoAtivo;